import { render, staticRenderFns } from "./OrderItemsTable.vue?vue&type=template&id=5196f558"
import script from "./OrderItemsTable.vue?vue&type=script&lang=js"
export * from "./OrderItemsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports